import { zeroPrice } from "../prices/price";
import { subtractFromPrice } from "../prices/subtract-from-price";
import { sumPrices } from "../prices/sum-prices";
import type { OrderEvent } from "./order-events/events/_order-event";

//Warning not using service fee
const calculateRefundedOrderPrice = (orderEvents: OrderEvent[]) => {
    const refunded = sumPrices(
        orderEvents.map(h => {
            if (h.type === "PAYMENT_REFUND_FULFILLED") return h.refundedAmount;
            return zeroPrice;
        }),
    );
    return refunded;
};
//Warning not using service fee
const calculatePaidOrderPrice = (orderEvents: OrderEvent[]) => {
    const paid = sumPrices(
        orderEvents.map(h => {
            if (h.type === "PAYMENT_FULFILLED") return h.paidAmount;
            return zeroPrice;
        }),
    );
    const refunded = sumPrices(
        orderEvents.map(h => {
            if (h.type === "PAYMENT_REFUND_FULFILLED") return h.refundedAmount;
            return zeroPrice;
        }),
    );

    return subtractFromPrice(paid, [refunded]);
    // return order.totalPrice.amountIncludingVat - refunded;
};

export { calculatePaidOrderPrice, calculateRefundedOrderPrice };
